// COOMEVA-INICIO: JS cupón + cédula (M-03). Archivo completo. Ver REVERSION.md
// === Cupón Coomeva / descuentos en carrito ===
// Delegación de eventos: un solo listener en document, sobrevive los repintados
// del carrito AJAX (updateView reemplaza el innerHTML del carrito).

(function () {
  var MSG_INVALID = 'Este cupón no es válido. Revísalo e intenta de nuevo.';
  var MSG_APPLYING = 'Aplicando…';
  var MSG_REMOVING = 'Quitando…';

  function getConfig() {
    var el = document.getElementById('cart-config');
    if (!el) return null;
    try { return JSON.parse(el.innerHTML || '{}'); }
    catch (e) { return null; }
  }

  // Repinta el carrito usando las funciones globales del tema.
  function refreshCart() {
    var config = getConfig();
    if (!config || !window.Shopify || !Shopify.theme || !Shopify.theme.cart || !Shopify.theme.ajaxCart) {
      // Fallback: recarga completa si el tema no expone las funciones.
      window.location.reload();
      return Promise.resolve();
    }
    return Shopify.theme.cart.getCart().then(function (Cart) {
      Shopify.theme.ajaxCart.updateView(config, Cart);
    });
  }

  // POST a cart/update.js con un discount (aplicar o quitar con '').
  function updateDiscount(code) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }

  // Lee el cart actual y devuelve la lista de títulos de descuentos aplicados.
  function getAppliedDiscountTitles() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.cart_level_discount_applications || []).map(function (a) { return a.title; });
      });
  }

  function setMsg(text, isError) {
    var msg = document.querySelector('.js-coomeva-coupon-msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('is-error', !!isError);
  }

  function setBusy(busy) {
    var btn = document.querySelector('.js-coomeva-coupon-apply');
    if (btn) btn.disabled = busy;
  }

  // Aplicar cupón
  function applyCoupon() {
    var input = document.querySelector('.js-coomeva-coupon-input');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) return;

    setBusy(true);
    setMsg(MSG_APPLYING, false);

    updateDiscount(code)
      .then(function () { return getAppliedDiscountTitles(); })
      .then(function (titles) {
        // Comparación case-insensitive: Shopify aplica el código como venga.
        var applied = titles.some(function (t) {
          return t && t.toLowerCase() === code.toLowerCase();
        });
        if (applied) {
          setMsg('', false);
          return refreshCart();
        } else {
          // El código no quedó aplicado → inválido / no aplicable.
          setMsg(MSG_INVALID, true);
          setBusy(false);
        }
      })
      .catch(function () {
        setMsg(MSG_INVALID, true);
        setBusy(false);
      });
  }

  // Quitar cupón (vacía el descuento del carrito y la cédula asociada)
  function removeCoupon() {
    setBusy(true);
    setMsg(MSG_REMOVING, false);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '', attributes: { cedula: '' } })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        setMsg('', false);
        return refreshCart();
      })
      .catch(function () { setBusy(false); });
  }

  // --- Delegación de eventos ---
  document.addEventListener('click', function (e) {
    var applyBtn = e.target.closest && e.target.closest('.js-coomeva-coupon-apply');
    if (applyBtn) {
      e.preventDefault();
      applyCoupon();
      return;
    }
    var removeBtn = e.target.closest && e.target.closest('.js-coomeva-coupon-remove');
    if (removeBtn) {
      e.preventDefault();
      removeCoupon();
      return;
    }
  });

  // Enter en el input aplica el cupón.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.classList && e.target.classList.contains('js-coomeva-coupon-input')) {
      e.preventDefault();
      applyCoupon();
    }
  });

  // Validación del campo cédula con mensajes en español (delegado en input).
  var CEDULA_PATTERN = /^[A-Za-z0-9-]{6,}$/;
  var MSG_CEDULA_EMPTY = 'Este dato es obligatorio para aplicar el descuento  - Fecoomeva.';
  var MSG_CEDULA_INVALID = 'Ingresa un documento válido: solo letras, números y guiones (mínimo 6 caracteres).';

  function validateCedula(input) {
    var v = (input.value || '').trim();
    if (v === '') {
      input.setCustomValidity(MSG_CEDULA_EMPTY);
    } else if (!CEDULA_PATTERN.test(v)) {
      input.setCustomValidity(MSG_CEDULA_INVALID);
    } else {
      input.setCustomValidity('');
    }
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('js-coomeva-cedula-input')) {
      validateCedula(e.target);
    }
  });

  // Al intentar enviar el form (checkout), valida la cédula si está presente.
  document.addEventListener('submit', function (e) {
    var input = document.querySelector('.js-coomeva-cedula-input');
    if (input) validateCedula(input);
  }, true);

  // --- Popup del convenio (abrir/cerrar) ---
  function openModal() {
    var modal = document.querySelector('.js-coomeva-modal');
    if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
  }
  function closeModal() {
    var modal = document.querySelector('.js-coomeva-modal');
    if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-coomeva-popup-open')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest && e.target.closest('.js-coomeva-modal-close')) {
      e.preventDefault();
      closeModal();
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();

// COOMEVA-FIN